export default {
  meta: {
    title: '订单管理'
  }
};
